<template>
  <div>
    <h1>Play a random interval</h1>
    <button @click.prevent="play">
        Play
    </button>
  </div>
</template>
<script>

import Tone from 'tone'

export default {
  data () {
    return {}
  },
  methods: {
    play () {
      // create a synth and connect it to the master output (your speakers)
      var polySynth = new Tone.PolySynth(4, Tone.Synth).toMaster()
      // play a random interval
      polySynth.triggerAttackRelease(this.randomInterval(), '2n')
    },
    randomInterval () {
      let intervals = [
        ['C4', 'E4'],
        ['C4', 'F4'],
        ['C4', 'G4'],
        ['C4', 'A4'],
        ['C4', 'B4']
      ]

      return intervals[Math.floor(Math.random() * intervals.length)]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/IntervalView.vue